import React from "react";
import MoneyOverview from "./MoneyOverview";
import Revenue from "../Revenue";

export default function MoneyPayouts() {
  return (
    <div className="space-y-6" data-testid="money-payouts-workspace">
      <MoneyOverview />
      <Revenue />
    </div>
  );
}